/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from '@/components/cusPagination.vue';
import {refundGet} from "@/api/refund"
import {fileEcho, shopDetail} from "@/api/url"

export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            loading: true,
            searchForm: {
                orderNo: '',
                goodsName: '',
                goodsUnionld: '',
                storeName: '',
                buyerName: '',
                orderItemStatus: '',
                status: '',
                reason: '',
                createdDate: '',
            },
            Processed: false,//页头-已处理切换
            stateText: '',
            tableData: [],
            tableDataLoc: fileEcho,
            tabsCut: 0,//页头切换
            currentPage: 1,
            pageSize: 10,
            total: 0,
        };
    },
    // 自定义方法
    methods: {
        //搜索
        seachBtn() {
            console.log(this.searchForm);
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.orderNo = '';
            this.searchForm.goodsName = '';
            this.searchForm.goodsUnionld = '';
            this.searchForm.storeName = '';
            this.searchForm.buyerName = '';
            this.searchForm.orderItemStatus = '';
            this.searchForm.status = '';
            this.searchForm.reason = '';
            this.searchForm.createdDate = '';
            this.cutCreatedDate = ''
            this.getList();
        },
        //获取数据
        getList() {
            if (this.searchForm.createdDate.length > 0) {
                this.cutCreatedDate = (this.searchForm.createdDate[0] + ',' + this.searchForm.createdDate[1])
            }
            this.loading = true;
            this.$ajax.get(refundGet, {
                orderNo: this.searchForm.orderNo,
                goodsName: this.searchForm.goodsName,
                goodsUnionld: this.searchForm.goodsUnionld,
                storeName: this.searchForm.storeName,
                buyerName: this.searchForm.buyerName,
                orderItemStatus: this.searchForm.orderItemStatus,
                status: this.searchForm.status || this.stateText,
                reason: this.searchForm.reason,
                Processed: this.Processed,
                createdDate: this.cutCreatedDate,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.loading = false;
                }
            }, (err) => {
                console.log(err);
            })
        },
        cut(num) {
            console.log(num);
            if (num == 0) {
                this.tabsCut = 0;
                this.stateText = '';
                this.getList();
            } else if (num == 1) {
                this.tabsCut = 1;
                this.Processed = false;
                this.stateText = 'TOREFUND';
                this.getList();
            } else if (num == 2) {
                this.tabsCut = 2;
                this.stateText = '';
                this.Processed = true;
                this.getList();
            }
        },
        detailsBtn(item) {
            let id = window.btoa(item.id);
            this.$router.push({path: '/refundDetail', query: {id: id}});
        }
    },
    // 数据观察监听
    watch: {
        currentPage(newData, oldData) {
            this.getList()
        },
        pageSize(newData, oldData) {
            this.getList()
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        if (this.$route.query.shopId != undefined) {

            this.$ajax.get(shopDetail(this.$route.query.shopId), {
                id: this.$route.query.shopId
            }).then(res => {
                console.log(res);
                this.searchForm.storeName = res.data.name;
                if (this.$route.query.type != undefined) {
                    if (this.$route.query.type == '') {
                        this.tabsCut = 0;
                        // this.stateText = '';
                        this.searchForm.orderItemStatus = this.$route.query.orderItemStatus;
                        console.log(this.$route.query.orderItemStatus);
                        this.getList();
                    } else if (this.$route.query.type == '0') {
                        this.tabsCut = 1;
                        this.Processed = false;
                        // this.stateText = 'TOREFUND';
                        this.searchForm.orderItemStatus = this.$route.query.orderItemStatus;
                        this.getList();
                    } else if (this.$route.query.type == '1') {
                        this.tabsCut = 2;
                        // this.stateText = '';
                        this.Processed = true;
                        this.searchForm.orderItemStatus = this.$route.query.orderItemStatus;
                        this.getList();
                    }
                }
            }, err => {
                console.log(err);
            })
        } else {
            this.getList()
        }

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
